/**
 * Provider booking flow contract (mirrors backend ACTIVE_PROVIDER_BOOKING_STATUSES
 * and the ProviderBookingDetail START TRIP conditions).
 *
 - A paid booking becomes CONFIRMED (payment service, base booking flow).
 - The dashboard card + /providers/me/active-booking show the booking while it is
   payment_pending / confirmed / in_progress.
 - Start Trip appears exactly when status is confirmed and travel has not started.
 */

export const PROVIDER_ACTIVE_BOOKING_STATUSES = [
  'payment_pending',
  'confirmed',
  'in_progress',
];

export function isVisibleOnProviderDashboard(booking) {
  return Boolean(
    booking && booking.id && PROVIDER_ACTIVE_BOOKING_STATUSES.includes(booking.status),
  );
}

export function canStartTrip(booking) {
  return Boolean(booking && booking.status === 'confirmed' && booking.travel_status === 'not_started');
}
